$ = require 'jquery'
Auth = require 'app/scripts/db/auth'
Confirm = require 'app/scripts/views/lib/confirm'
StickerSelectionView = require 'app/scripts/views/stickers/sticker-selection-view'
Util = require 'app/scripts/lib/util'

module.exports = class CustomStickerSelectionView extends StickerSelectionView
  initialize: ->
    @toggleSelectable()
    @waitForId @model, =>
      @toggleSelectable()

    @listenTo @model, 'change:error', @render

  events:
    'click .js-delete-sticker': 'deleteSticker'

  enabled: ->
    Auth.me().isFeatureEnabled('customStickers') || @options.org?.isFeatureEnabled('customStickers')

  toggleSelectable: ->
    selectable = @model.id?
    @$el.toggleClass('js-draggable-sticker', selectable)
    @$el.toggleClass('sticker-unselectable', !selectable)

  deleteSticker: (e) ->
    Util.stop(e)

    Confirm.toggle 'delete sticker',
      elem: $(e.target).closest('.js-delete-sticker')
      top: 32
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.destroy()
